<template>
    <div class="table-responsive">
        <table class="table">
            <thead>
            <tr>
            <th colspan="5" class="pdfFiles">{{ $t('sandoz.user_files') }}
                <div class="float-right show-deleted-checkbox" v-if="item.id && item.id !== 'new' && (user && user.is_super_user)">
                <div class="w-100">
                    <b-form-checkbox v-model="showDeletedFiles" value="true" @change="showDeleted">{{$t('sandoz.show_deleted_files')}}</b-form-checkbox>
                </div>
                </div>
            </th>
            </tr>
            <tr>
                <th class="col-sm-1">{{$t('core.id')}}</th>
                <th class="col-sm-5">{{$t('sandoz.file_name')}}</th>
                <th class="col-sm-2">{{$t('sandoz.user')}}</th>
                <th class="col-sm-2">{{$t('sandoz.date')}}</th>
                <th class="col-sm text-right">
                    <b-form-file  class="d-none" v-model="wordfile" ref="fileinput" @change="addToWordFiles" accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain></b-form-file>
                    <b-btn @click.prevent="addFile()" variant="primary">
                    <fa icon="plus"/>
                    </b-btn>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(file, i) in item.word_files" :key="i" :class="file.deleted_at !== null && showDeletedFiles ? 'bg-disable' : ''">
            <td>{{file.id}}</td>
            <td>
                <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                <o-button type="button" variant="primary" @click.prevent="word(i)">
                    <fa :icon="getExtension(file.file_name.name)"/>
                </o-button>
                </div>
                {{file.file_name ? file.file_name.name: null}}
            </td>
            <td>{{file.user ? file.user.name: null}}</td>
            <td>{{file.created_at | formatDate}}</td>
            <td class="text-right text-nowrap">
                <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                <b-btn @click.prevent="deleteWordFile(file.id, i)"
                        variant="secondary" v-if="file.deleted_at === null">
                    <fa icon="times"/>
                </b-btn>
                </div>
            </td>
            </tr>
            <tr class="mt-5">
            <th colspan="5" class="pdfFiles">{{ $t('sandoz.pdf_files') }}
                {{ }}
                <div class="float-right show-deleted-checkbox" v-if="item.id && item.id !== 'new' && (user && user.is_super_user)">
                <div class="w-100">
                    <b-form-checkbox v-model="showDeletedPDFFiles" value="true" @change="showPDFDeleted">{{$t('sandoz.show_deleted_files')}}</b-form-checkbox>
                </div>
                </div>
            </th>
            </tr>
            <tr class="border-bottom-double">
            <th class="col-sm-1">{{$t('core.id')}}</th>
            <th class="col-sm-5">{{$t('sandoz.file_name')}}</th>
            <th class="col-sm-2">{{$t('core.user')}}</th>
            <th class="col-sm-2">{{$t('sandoz.date')}}</th>
            <th class="col-sm"></th>
            </tr>
            <tr v-for="(pdf, i) in item.pdfs" :key="i" :class="pdf.deleted_at !== null && showDeletedPDFFiles ? 'bg-disable' : ''">
            <td>{{pdf.id}}</td>
            <td>
                <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                <o-button type="button" variant="primary"
                            @click.prevent="download(pdf)">
                    <fa icon="file-pdf"/>
                </o-button>
                </div>
                {{pdf.file_name.substr(11)}}
            </td>
            <td>{{pdf.user? pdf.user.name : ""}}</td>
            <td>{{pdf.created_at | formatDate}}</td>
            <td></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
  import axios from 'axios'

  export default {
    props: {
        item : {
            type: Object,
        },
        user: {
            type: Object,
        }
    },
    data: () => ({
        showDeletedFiles: false,
        showDeletedPDFFiles: false,
        wordfile : null,
        newFileCounter: 0,
    }),
    methods: {
        showDeleted() {
            let url = '/api/contractDeletedFiles?show_deleted='+this.showDeletedFiles+'&contract_id='+this.item.id
            axios
                .get(url)
                .then((response) => {
                this.item.word_files = response.data.word_files
            })
        },
        addToWordFiles(evt) {
            var fileName = evt.target.value.replace(/^.*[\\/]/, '')
            var files = evt.target.files
            var file = files[0]

            if (!file) {
                return
            }

            if (file) {
                var reader = new window.FileReader()
                const self = this
                reader.onload = function (readerEvt) {
                    let wordOb = {
                        id : self.item.id !== 'new' && self.item.id !== undefined ? null : 'NEW_TEMP_ID_' + (++self.newFileCounter),
                        contract_id : self.item.id,
                        user_id: self.user.id,
                        user: self.user,
                        file_name: {
                        data: readerEvt.target.result,
                        name: fileName
                        }
                    }

                    if(self.item.id !== 'new'  && self.item.id !== undefined) {
                        self.uploadWordFile(wordOb)
                    } else {
                        self.item.word_files.push(wordOb);
                        self.wordfile = null;
                    }
                }
                reader.readAsDataURL(file)
            }
        },
        uploadWordFile(obj) {
            axios.post(`/api/sandoz/contract_word_file/new?include=user`,obj)
            .then((response) => {
                this.$notify({
                title: this.$i18n.t('core.saved'),
                text: this.$i18n.t('core.saved_text')
                })

                this.item.word_files.push(response.data);
                this.wordfile = null;
            }).catch((error) => {
            })
        },
        addFile() {
            this.$refs.fileinput.$refs.input.click()
        },
        word (i) {
            if (i !== null) {
                const file = this.item.word_files[i]
                axios.post('/api/sandoz/contract_word_file/download', {
                'id': file.id
                }, {responseType: 'arraybuffer'})
                    .then((response) => {
                    require('downloadjs')(
                        response.data,
                        file.file_name.name,
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                    )
                    }).catch((error) => {
                console.log(error)
                })
            }
        },
        getExtension(fileName) {
            if(fileName !== '') {
                var ext = fileName.split('.').pop()

                if(ext === 'doc' || ext === 'docx') {
                return 'file-word'
                } else if(ext === 'odt' || ext === 'txt') {
                return 'file-text'
                } else if(ext === 'pdf') {
                return 'file-pdf'
                } else if(ext === 'xls' || ext === 'xlsx' || ext === 'ods') {
                return 'file-excel'
                } else if(ext === 'ppt' || ext === 'pptx') {
                return 'file-powerpoint'
                }
                return 'file'
            }
        },
        deleteWordFile(id, i) {
            if(this.item.id !== 'new') {

                this.$notify({
                title: this.$i18n.t('core.saved'),
                text: this.$i18n.t('core.saved_text')
                })

                axios.delete(`/api/sandoz/contract_word_file/${id}`)
                .then((response) => {
                    this.item.word_files.splice(i, 1)
                }).catch((error) => {
                })
            } else {
                this.item.word_files.splice(i, 1)
            }
        },
        showPDFDeleted() {
            let url = '/api/contractDeletedPDFFiles?show_deleted='+this.showDeletedPDFFiles+'&contract_id='+this.item.id
            axios
                .get(url)
                .then((response) => {
                this.item.pdfs = response.data.pdf_files
            })
        },
        download (pdf = null) {
            axios.post('/api/sandoz/contract_pdfs/download', {
                'id': pdf.id
            }, { responseType: 'arraybuffer' })
                .then((response) => {
                require('downloadjs')(response.data,
                    pdf.file_name, 'application/pdf'
                )
                }).catch((error) => {
                console.log(error)
            })
        },
    }
  }
</script>